import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const Separator = ({
  orientation = 'horizontal',
  classes,
}: {
  classes?: Array<string>
  orientation?: string
}) => {
  const useStyles = makeStyles({
    horizontal: {
      height: '1px',
      width: '100%',
    },
    vertical: {
      width: '1px',
    },
  })
  const classStyles = useStyles()

  return (
    <div
      className={`${(classes && classes.join(' ')) as string} ${
        orientation === 'vertical' ? classStyles.vertical : classStyles.horizontal
      }`}
    />
  )
}

export default Separator
